import script from "./MobileInterview.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileInterview.vue?vue&type=script&setup=true&lang=js"

import "./MobileInterview.vue?vue&type=style&index=0&id=c5099f3a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5099f3a"]])

export default __exports__